export default {
  name: "CirclePlusInTriangle",
  props: {
    colors: {
      type: String,
      default: 'RGBGRGB'
    }
  },
  data() {
    return {
      color: {
        'R': 'red',
        'G': 'green',
        'B': 'blue'
      }
    };
  },
  methods: {
    init() {}
  },
  mounted() {
    this.init();
  }
};